import apiService from "../../api/api.service";
import telematicsService from "../../api/telematics.service";
import pageheader from "../pageheader";
import utils from "../../utils/util";
import { mapGetters } from "vuex";
import moment from "moment";
import XLSX from "xlsx";

export default {
  name: "usersList",
  components: {
    pageheader,
  },
  props: ["clientIdFromClient"],
  data: () => ({
    keydata: null,
    headers: [
      {
        text: "SNO",
        align: "center",
        sortable: false,
        value: "sno",
      },
      {
        text: "Customers",
        value: "customerNames",
        width: "200px",
        align: "",
      },
      { text: "", value: "image", width: "5px", fixed: true },
      { text: "Name", value: "firstName" },
      { text: "Email", value: "email", width: "200px" },

      { text: "Role", value: "role" },
      { text: "Mobile Number", value: "phoneNumber" },
      { text: "Last Login", value: "lastLoginTime" },

      { text: "Action", value: "action", width: "200px" },
    ],
    headers_Logs: [
      {
        text: "SNO",
        align: "center",
        sortable: false,
        value: "sno",
        width: "3%",
      },
      {
        text: "Browser",
        align: "center",
        sortable: false,
        value: "browser",
        width: "40%",
      },
      { text: "IP Address", value: "ipAddress", width: "10%" },
      { text: "Last Login", value: "lastLogin", width: "15%" },
      { text: "Message", value: "message", width: "15%" },
    ],
    search: "",
    resetdialog: false,
    resenddialog: false,
    dialog: false,
    users: [],
    options: {},
    loading: false,
    loadingresend: false,
    exportListUser: [],
    exportHeaderUser: [],
    startrowUsers: "",
    isExcelLoading: false,
    deleteId: null,
    deleteUserName: "",
    delName: "",
    isdelete: false,
    resetFirstName: "",
    resetLastName: "",
    resetEmail: "",
    role: "",
    idOnboarding: "",
    input: {},
    nodata: false,
    logname: "",
    logemail: "",
    isFilter: false,
    isDisplayInfoLogsDialog: false,
    userslogs: [],
    iscustomerDataLoading: false,
    notificationContactsArr: [],
    selectedCustomer: [],
    isNotificationContactsLoading: false,
    isUsersUpdating: false,
    parentCompaniesList: [],
  }),
  filters: {
    formatDateTime: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment(value).format(format);
      }
    },
    formattoLocalDate: function (value) {
      if (value) {
        const format = "MM/DD/YYYY hh:mm:ss A";
        return moment.utc(value).local().format(format);
      }
    },
  },
  mounted() {
    this.getCompanyList();
    this.role = this.$store.getters.roles;
    this.input = utils.getInputContent("usermanagement", this.roles);
    if (this.$route.query && this.$route.query.isFilter) {
      this.search = this.$route.query.filterVal;
      this.isFilter = this.$route.query.isFilter;
    }
    if (this.clientIdFromClient) {
      this.notificationAllContacts();
    }
    if (this.clientIdFromClient && this.headers && this.headers[4]) {
      this.headers[4].align = " d-none";
    }
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    async getCompanyList() {
      this.loading = true;
      this.parentCompaniesList = [];
      try {
        const response = await telematicsService.getBasicCustomers();
        if (response.isSuccess) {
          this.parentCompaniesList = response.data.filter((e) => e.name !== "");
        } else {
          this.parentCompaniesList = [];
        }
        this.readDataFromAPI();
      } catch (err) {
        this.readDataFromAPI();
        console.log(err);
      }
    },
    async openInfoLogsDialog(item) {
      this.isDisplayInfoLogsDialog = true;
      this.iscustomerDataLoading = true;
      this.nodata = false;
      try {
        let userslogs;
        this.logname = item.firstName + " " + item.lastName;
        this.logemail = item.email;
        userslogs = await apiService.getLogsByUserId(item.id);

        this.userslogs = userslogs.data.map((d, index) => ({
          ...d,
          sno: index + 1,
        }));
        if (this.userslogs == null && this.userslogs.length == 0) {
          this.nodata = true;
          this.userslogs = [];
        }
        this.iscustomerDataLoading = false;
      } catch (err) {
        this.iscustomerDataLoading = false;

        this.nodata = true;
      }
    },
    closeLogsDialog() {
      this.nodata = false;
      this.logname = "";
      this.logemail = "";
    },
    addUser() {
      if (this.isFilter) {
        this.$router.push({
          name: "user-management",
          query: {
            filterVal: this.search,
            isFilter: this.isFilter,

            from:
              this.$route.name == "View Customer Details" ? "FromCustomer" : "",
            CustomerDetailsId:
              this.$route.name == "View Customer Details"
                ? this.$route.params.id
                : "",
            SearchCust:
              this.$route.name == "View Customer Details"
                ? this.$route.query.search
                : "",
          },
        });
      } else {
        this.$router.push({
          name: "user-management",
          query: {
            filterVal: "",
            isFilter: this.isFilter,

            from:
              this.$route.name == "View Customer Details" ? "FromCustomer" : "",
            CustomerDetailsId:
              this.$route.name == "View Customer Details"
                ? this.$route.params.id
                : "",
            SearchCust:
              this.$route.name == "View Customer Details"
                ? this.$route.query.search
                : "",
          },
        });
      }
    },
    async readDataFromAPI() {
      this.isProfile = true;
      this.loading = true;
      try {
        let usersListRes;
        if (this.clientIdFromClient) {
          usersListRes = await apiService.getUsersByCustId(
            this.clientIdFromClient
          );
        } else {
          usersListRes = await apiService.getUsers();
        }
        if (usersListRes) {
          this.loading = false;
          this.users = usersListRes.data.map((d, index) => ({
            ...d,
            sno: index + 1,
          }));
          for (let u = 0; u < this.users.length; u++) {
            let userNames = [];
            if (this.users[u].role == "Customer") {
              userNames = this.parentCompaniesList.filter((c) =>
                this.users[u].custId
                  ? this.users[u].custId.includes(c.id ? c.id.toString() : "")
                  : false
              );
              this.users[u]["customerNames"] = userNames
                ? userNames.map((u) => u.name).join(",")
                : "";
            } else {
              this.users[u]["customerNames"] = "";
            }
          }
        }
      } catch (err) {
        this.$toast.error("Unable to load the users" + err);
        this.loading = false;
      }
    },
    async exportTableDataUsers() {
      this.exportHeaderUser = [];
      this.isExcelLoading = true;
      try {
        let response = await apiService.getUsers();
        if (response) {
          this.isExcelLoading = false;
          let excelList = response.data;
          for (let u = 0; u < excelList.length; u++) {
            let userNames = [];
            if (excelList[u].role == "Customer") {
              userNames = this.parentCompaniesList.filter((c) =>
                excelList[u].custId
                  ? excelList[u].custId.includes(c.id ? c.id.toString() : "")
                  : false
              );
              excelList[u]["customerNames"] = userNames
                ? userNames.map((u) => u.name).join(",")
                : "";
            } else {
              excelList[u]["customerNames"] = "";
            }
          }
          const formatDateTime = "MM/DD/YYYY hh:mm:ss A";

          this.exportListUser = excelList.map((item) => {
            return {
              firstName: item.firstName
                ? item.firstName + " " + item.lastName
                : "",
              email: item.email ? item.email : "",
              customers: item.customerNames ? item.customerNames : "",
              role: item.role ? item.role : "",
              phoneNumber: item.phoneNumber
                ? item.phoneCountryCode
                  ? "(+" + item.phoneCountryCode + ") " + item.phoneNumber
                  : item.phoneNumber
                : "",
              lastLoginTime: item.lastLoginTime
                ? moment(item.lastLoginTime).format(formatDateTime)
                : "",
            };
          });
          this.startrowUsers = 3;
          this.exportHeaderUser.push(["Users Data"]);
          this.startrowUsers += 1;

          this.exportHeaderUser.push([]);

          this.exportHeaderUser.push([
            "Customers",
            "Name",
            "Email",
            "Role",
            "Phone",
            "Last Login",
          ]);
          let tempExcel = this.exportListUser;
          let datarow = "A" + this.startrowUsers;
          var ws = XLSX.utils.aoa_to_sheet(this.exportHeaderUser);
          XLSX.utils.sheet_add_json(ws, tempExcel, {
            header: [
              "customers",
              "firstName",
              "email",
              "role",
              "phoneNumber",
              "lastLoginTime",
            ],
            skipHeader: true,
            origin: datarow,
          });
          var wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "User Management Data");
          this.exportHeaderUser = [];
          XLSX.writeFile(wb, "User Management Data.xlsx");
        } else {
          this.isExcelLoading = false;
          this.exportListUser = [];
          this.$toast.error(response.systemMessage);
        }
      } catch (err) {
        console.log(err);
        this.isExcelLoading = false;
        this.$toast.error("Unable to load the Data" + err);
      }
    },
    async deleteUser() {
      try {
        this.isdelete = true;
        let payload = {
          userId: this.deleteId,
          userName: this.deleteUserName,
        };
        let delUser = await apiService.removeUser(payload);
        if (delUser) {
          this.isdelete = false;
          this.$toast.success(delUser.systemMessage);
          this.readDataFromAPI();
          this.dialog = false;
        }
      } catch (err) {
        this.isdelete = false;
        this.$toast.error("Unable to delete user" + err);
        this.dialog = false;
      }
    },
    confirmDelete(item) {
      this.deleteId = item.id;
      this.delName = item.firstName + " " + item.lastName;
      this.deleteUserName = item.userName;
      this.dialog = true;
    },
    findUserKey(userId) {
      for (var key = 0; key < this.users.length; key++) {
        if (this.users[key].userId == userId) {
          return key;
        }
      }
    },
    ResetPassword(Fname, Lname, email) {
      this.resetFirstName = Fname;
      this.resetLastName = Lname;
      this.resetEmail = email;
      this.resetdialog = true;
    },
    ResendUserOnboarding(id, sno) {
      this.keydata = sno;

      this.idOnboarding = id;
    },
    async ResendUserOnboardingConfirm() {
      try {
        this.loadingresend = true;
        this.resenddialog = false;
        let response = await apiService.ResendUserOnboarding(this.idOnboarding);
        if (response.isSuccess == true) {
          this.$toast.success(response.systemMessage);
          this.loadingresend = false;
        } else {
          this.$toast.success(response.systemMessage);
          this.loadingresend = false;
        }
        this.loadingresend = false;
      } catch (error) {
        this.$toast.error("Unable to Reseend the link" + error);
        this.loadingresend = false;
      }
    },
    async GetResetPassword() {
      try {
        this.resetdialog = false;
        let payload = {
          userEmail: this.resetEmail,
        };
        let response = await apiService.Resetpassword(payload);
        if (response.isSuccess == true) {
          this.$toast.success(response.systemMessage);
        } else {
          this.$toast.success(response.systemMessage);
        }
      } catch (error) {
        this.resetdialog = false;
        this.$toast.error("Unable to Reset the password" + error);
        this.loading = false;
      }
    },
    onSearch() {
      if (this.search) {
        this.isFilter = true;
      } else {
        this.isFilter = false;
      }
    },
    clearSearch() {
      this.search = "";
      this.$router.replace(`/user-management/list`);
      this.readDataFromAPI();
    },
    editUser(item) {
      if (this.isFilter) {
        this.$router.push({
          name: "editUser",
          params: { id: item.id },
          query: {
            filterVal: this.search,
            isFilter: this.isFilter,
            type: "edit",
            from:
              this.$route.name == "View Customer Details" ? "FromCustomer" : "",
            CustomerDetailsId:
              this.$route.name == "View Customer Details"
                ? this.$route.params.id
                : "",
            SearchCust:
              this.$route.name == "View Customer Details"
                ? this.$route.query.search
                : "",
          },
        });
      } else {
        this.$router.push({
          name: "editUser",
          params: { id: item.id },
          query: {
            filterVal: "",
            isFilter: this.isFilter,
            type: "edit",
            from:
              this.$route.name == "View Customer Details" ? "FromCustomer" : "",
            CustomerDetailsId:
              this.$route.name == "View Customer Details"
                ? this.$route.params.id
                : "",
            SearchCust:
              this.$route.name == "View Customer Details"
                ? this.$route.query.search
                : "",
          },
        });
      }
    },
    async notificationAllContacts() {
      this.isNotificationContactsLoading = true;
      try {
        let response = await apiService.getAllUsers();
        if (response.data) {
          this.notificationContacts();
          this.notificationContactsArr = response.data.map((d, index) => ({
            ...d,
            fullName: d.firstName + " " + d.lastName,
            sno: index + 1,
          }));
        } else {
          this.isNotificationContactsLoading = false;
          this.notificationContactsArr = [];
        }
      } catch (err) {
        console.log(err);
        this.isNotificationContactsLoading = false;
      }
    },
    async notificationContacts() {
      try {
        let response = await apiService.getNotificationContacts(
          this.$route.params.id
        );
        if (response.data) {
          this.isNotificationContactsLoading = false;
          this.selectedCustomer = response.data;
        } else {
          this.isNotificationContactsLoading = false;
          this.selectedCustomer = [];
        }
      } catch (err) {
        console.log(err);
        this.isNotificationContactsLoading = false;
      }
    },
    async updateContacts() {
      try {
        this.isUsersUpdating = true;
        let result = await apiService.putNotificationContacts(
          this.$route.params.id,
          this.selectedCustomer
        );

        if (result.isSuccess) {
          this.$toast.success("updated successfully");
        }
        this.isUsersUpdating = false;
      } catch (err) {
        this.isUsersUpdating = false;
        this.$toast.error("Unable to update " + err);
      }
    },
  },
};
